package com.partejar.app.feature.contratos.presentation

import com.partejar.app.feature.contratos.data.SignatureLink
import kotlin.time.Instant

internal enum class SignatureLinkValidity { ACTIVE, EXPIRED, UNKNOWN }

internal data class SignatureLinkExpiry(val validity: SignatureLinkValidity, val remaining: String? = null)

/** Display/copy protection only. The backend still validates and consumes the token. */
internal fun signatureLinkExpiry(link: SignatureLink, now: Instant): SignatureLinkExpiry {
    // Never interpret a server wall-clock timestamp using the device's timezone.
    val expiration = runCatching { Instant.parse(link.expiresAtInstant ?: link.expiresAt) }.getOrNull()
        ?: return SignatureLinkExpiry(SignatureLinkValidity.UNKNOWN)
    if (expiration <= now) return SignatureLinkExpiry(SignatureLinkValidity.EXPIRED)
    val minutes = ((expiration - now).inWholeMilliseconds + 59_999) / 60_000
    val hours = minutes / 60
    val remaining = if (hours > 0) "${hours}h ${minutes % 60}min" else "${minutes}min"
    return SignatureLinkExpiry(SignatureLinkValidity.ACTIVE, remaining)
}
